import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Navbar } from "./components/Navbar";
import { HeroSection } from "./components/HeroSection";
import { ProblemSection } from "./components/ProblemSection";
import { AboutSection } from "./components/AboutSection";
import { CredibilitySection } from "./components/CredibilitySection";
import { VideoSection } from "./components/VideoSection";
import { OfferStackSection } from "./components/OfferStackSection";
import { DreamOutcomeSection } from "./components/DreamOutcomeSection";
import { ForNotForSection } from "./components/ForNotForSection";
import { SocialProofSection } from "./components/SocialProofSection";
import { LeadMagnetSection } from "./components/LeadMagnetSection";
import { FinalCTASection } from "./components/FinalCTASection";
import { Footer } from "./components/Footer";
import { WhatsAppButton } from "./components/WhatsAppButton";
import NRITaxPage from "./pages/NRITaxPage";
import CanadaTaxPage from "./pages/CanadaTaxPage";

const LandingPage = () => {
  return (
    <div className="min-h-screen" style={{ background: "#1a1c1b" }}>
      <Navbar />
      <HeroSection />
      <ProblemSection />
      <AboutSection />
      <CredibilitySection />
      <VideoSection />
      <OfferStackSection />
      <DreamOutcomeSection />
      <ForNotForSection />
      <SocialProofSection />
      <LeadMagnetSection />
      <FinalCTASection />
      <Footer />
      <WhatsAppButton />
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/nri-tax-filing" element={<NRITaxPage />} />
        <Route path="/canada-tax-filing" element={<CanadaTaxPage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
